import BaseApi from "./BaseApi";

export default class Unit extends BaseApi{
    construct() {}
    
    static async list(params) {
        let url = Unit.getFullApiUrl() + "list";

        return Unit.getAxiosInstance().get(url,{params: params});
    }

    static async create(params) {
        return await Unit.getAxiosInstance().post(Unit.getFullApiUrl(),params);
    }

    static async search(params) {
        return await Unit.getAxiosInstance().get(Unit.getFullApiUrl(),{params: params});
    }
    
    static async update(params, id) {
        return await Unit.getAxiosInstance().put(Unit.getFullApiUrl() + id,params);
    }

    static async delete(id) {
        return await Unit.getAxiosInstance().delete(Unit.getFullApiUrl() + id);
    }

    static async find(id) {
        return await Unit.getAxiosInstance().get(Unit.getFullApiUrl() + id);
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/units/";
    }

    static getFullApiUrl(){
        let domain = location.pathname.split('/')[1]
        return BaseApi.getFullDomainApiUrl() + "api/" + domain + "/admin/units/";
    }
    
}